/** Shared summary + score badge styles for TL / SV / team feedback views. */

export const FEEDBACK_SUMMARY_CARD_OUTER = {
  marginBottom: '22px',
  borderRadius: '12px',
  overflow: 'hidden',
  border: '1px solid #e2e8f0',
  boxShadow: '0 1px 3px rgba(15, 23, 42, 0.06)',
  background: '#f8fafc',
};

export const SUMMARY_DETAILS_GRID = {
  display: 'grid',
  gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))',
  gap: '12px 18px',
  padding: '16px 18px',
};

export const SUMMARY_DETAIL_ITEM = {
  minWidth: 0,
};

export const SUMMARY_DETAIL_LABEL = {
  fontSize: '12px',
  fontWeight: 600,
  color: '#98a2b3',
  textTransform: 'uppercase',
  letterSpacing: '0.03em',
  margin: 0,
  lineHeight: 1.3,
};

export const SUMMARY_DETAIL_VALUE_SMALL = {
  margin: '4px 0 0',
  fontSize: '14px',
  fontWeight: 600,
  color: '#0f172a',
  lineHeight: 1.4,
  wordBreak: 'break-word',
};

export const FEEDBACK_TABLE_HEAD_GRADIENT = {
  background: 'linear-gradient(135deg, rgb(102, 126, 234) 0%, rgb(118, 75, 162) 100%)',
};

export const formatScoreBadgeText = (value) => {
  const text = String(value ?? '').trim().toUpperCase();
  if (text === 'N/A') return 'NA';
  return value;
};

const METRIC_BADGE_MUTED = { bg: '#f3f4f6', color: '#6b7280' };
const METRIC_VALUE_PLAIN = { bg: 'transparent', color: '#334155' };
const AVERAGE_BADGE_PURPLE = { bg: 'rgba(102, 126, 234, 0.16)', color: '#5b21b6' };

export const metricScoreBadge = (val) => {
  const text = formatScoreBadgeText(val ?? '-');
  if (text === 'NA' || text === '-') return METRIC_BADGE_MUTED;
  const n = Number(val);
  if (!Number.isFinite(n)) return METRIC_BADGE_MUTED;
  return METRIC_VALUE_PLAIN;
};

export const averageScoreBadge = (val) => {
  const text = String(val ?? '').trim();
  if (text === 'NA' || text === '-') return METRIC_BADGE_MUTED;
  const n = Number(val);
  if (!Number.isFinite(n)) return METRIC_BADGE_MUTED;
  return AVERAGE_BADGE_PURPLE;
};
